import React, { useEffect, useRef } from "react";
import styles from "./ProfileContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../ui/Input/Input";
import Button from "../../ui/Button/Button";
import CloseIcon from "../../assets/icons/CloseIcon";
import { AddUsersContainer } from "../AddUsersContainer/AddUsersContainer";
import { CheckIcon, CopyIcon } from "@radix-ui/react-icons";
import { getEmployeeList } from "../../utils/api/actions/user";
import { errorToast } from "../../utils/methods/toast";

export const ProfileContainer = () => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const user = useSelector((state) => state?.user?.data);
  const [isCopy, setIsCopy] = React.useState(false);
  const [ID, setID] = React.useState("");

  useEffect(() => {
    dispatch(getEmployeeList(user?.id));
  }, [dispatch, user?.id]);

  const handleCopyText = () => {
    setIsCopy(true);
    navigator.clipboard.writeText(user.id);
    setTimeout(() => {
      setIsCopy(false);
    }, 2000);
  };

  const handlePasteFromClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (inputRef.current) {
        setID(text);
      }
    } catch (err) {
      errorToast("Ошибка чтения из буфера обмена");
      console.error("Ошибка чтения из буфера обмена:", err);
    }
  };

  return (
    <div className={styles.profilePage}>
      <ScreenHeader title={"Профиль"} />
      <div className={styles.card}>
        {" "}
        <div className={styles.userInfoContainer}>
          <div className={styles.title}>Ваш id</div>
          <div className={styles.rowUser}>
            <div className={styles.value}>{user.id}</div>
            <div
              className={`${styles.copyBtn} ${isCopy ? styles.copied : ""}`}
              onClick={handleCopyText}
            >
              {isCopy ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
            </div>
          </div>
        </div>
        <div className={styles.userInfoContainer}>
          <div className={styles.title}>ФИО</div>
          <div className={styles.rowUser}>
            <div className={styles.value}>{user.surname}</div>
            <div className={styles.value}>{user.firstName}</div>
            <div className={styles.value}>{user.patronymic}</div>
          </div>
        </div>
        <div className={styles.userInfoContainer}>
          <div className={styles.title}>Почта</div>
          <div className={styles.rowUser}>
            <div className={styles.value}>{user.email}</div>
          </div>
        </div>
        <div className={styles.migration}>
          <div className={styles.titleMigration}>
            Мигрция ассистентов и интеграций
          </div>
          <div className={styles.container}>
            <Input
              refFocus={inputRef}
              value={ID}
              placeholder={"ID"}
              rightIcon={<CloseIcon size={16} />}
              onClickRightIcon={() => setID("")}
              onChange={(e) => setID(e.target.value)}
              bottomString={
                "Вставьте сюда id человека, которому хотите передать ваших ассистентов и интеграции"
              }
              className={styles.inputContainer}
              inputStyle={styles.input}
            />
          </div>
          <div className={styles.btnContainer}>
            <Button
              className={styles.button}
              titleClassName={styles.buttonTitle}
              title={"Передать"}
            />
            <Button
              className={styles.button}
              titleClassName={styles.buttonTitle}
              title={"Вставить из буфера"}
              onClick={handlePasteFromClipboard}
            />
          </div>
        </div>
      </div>
      <AddUsersContainer />
    </div>
  );
};
